import landingLogo from "../../assets/login1Logo.png";
import axios from "axios";
import { Form, Input, Button, Tabs } from "antd";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { message } from "antd";

const { TabPane } = Tabs;

const SignIn = (props) => {
  const history = useNavigate();
  const [userCode, setUserCode] = useState("");
  const [password, setPassword] = useState("");
  const [finYear, setFinYear] = useState("");
  const [usertype, setUserType] = useState("Sales");
  const [codeIsValid, setCodeIsValid] = useState(true);
  const [passwordValid, setPasswordValid] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [site, setSite] = useState("");
  // const [siteValid, setSiteValid] = useState(true);
  const [enabledModules, setEnabledModules] = useState([]);
  const [label, setLabel] = useState("Report Writer");

  const userChange = (e) => {
    const value = e.target.value;
    if (value !== "") setCodeIsValid(true);
    else setCodeIsValid(false);
    
    setUserCode(value);
    
    if (!value) {
      setEnabledModules([]);
      return;
    }
  };

  const passwordChange = (e) => {
    if (e.target.value !== "") setPasswordValid(true);
    else setPasswordValid(false);

    setPassword(e.target.value);
  };

  const handleTabChange = (activeKey) => {
    if (activeKey === "employee") {
      setUserType("Sales");
      setLabel("Report Writer");
    } else {
      setUserType("Administrator Module");
      setLabel("Administrator Module");
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (userCode === "") setCodeIsValid(false);
    if (password === "") setPasswordValid(false);

    if (userCode !== "" && password !== "") {
      setCodeIsValid(true);
      setPasswordValid(true);

      const postData = {
        userCode,
        password,
        userType: usertype,
        finyear: finYear,
        unit: site,
        startDate,
        enddate: endDate,
      };

      axios
        .post(props.url + "/api/v1/users/login", postData, {
          withCredentials: true,
          credentials: "include",
        })
        .then((response) => {
          console.log(response.data, "responseA");

          // 👉 OTP verification needed
          if (response.data.status == "otp_required") {
            console.log("OTP required. Redirecting to /otp...");
            message.info({
              content: response.data.message,
              className: "custom-class",
              style: { marginTop: "20vh" },
            });

       
            history("/otp",  { state: { email: userCode }  });
            return;
          }
            // ✅ Step 1: Check subscription status
    axios
    .get(`${props.url}/api/v1/users/getSubscriptionPlanInfo/${userCode}`)
    .then((subResponse) => {
      const { subscribed } = subResponse.data;

      if (!subscribed) {
        if (usertype === "Administrator Module") {
          history("/plan", { state: { userCode } });
        } else if (usertype === "Sales") {
          message.error({
            content: "Please contact your administrator to activate your subscription.",
            className: "custom-class",
            style: { marginTop: "20vh" },
          });
        }
      }

      else {

          // 👇 Continue with login flow
          if (usertype === "Stock Control") history("/stock/dashboard");
          if (usertype === "Procurement Management") history("/purchase/dashboard");
          if (usertype === "Job Work") history("/jobwork/dashboard");
          if (usertype === "Payroll") history("/payroll/dashboard");
          if (usertype === "Production") history("/production/dashboard");
          if (usertype === "Financial Management") history("/finance/dashboard");
          if (usertype === "Gate Control") history("/gate/dashboard");
          if (usertype === "Sales") history("/sales/dashboard");
          if (usertype === "Trasporter") history("/transporter/dashboard");
          if (usertype === "Administrator Module") history("/admin/dashboard");
      }
    })
    .catch((err) => {
      console.error("Error checking subscription:", err);
      message.error("Failed to verify subscription.");
    });
    
        })
        .catch((error) => {
          message.error({
            content:
              error.response?.data?.message || "An error occurred during login",
            className: "custom-class",
            style: { marginTop: "20vh" },
          });
        });
    }
  };

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      // background: "linear-gradient(135deg, #1777C4, #4dabf7)"
    }}>
      <div style={{
        width: "450px",
        padding: "0px",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
        borderRadius: "16px",
        overflow: "hidden"
      }}>
        <Tabs 
          defaultActiveKey="employee" 
          onChange={handleTabChange}
          centered
          style={{
            marginBottom: "0"
          }}
          tabBarStyle={{
            marginBottom: "0",
            background: "#f0f0f0"
          }}
        >
          <TabPane 
            tab={
              <span style={{ 
                padding: "16px 24px", 
                fontWeight: "600",
                fontSize: "16px"
              }}>
                Employee Login
              </span>
            } 
            key="employee" 
          />
          <TabPane 
            tab={
              <span style={{ 
                padding: "16px 24px", 
                fontWeight: "600",
                fontSize: "16px"
              }}>
                Admin Login
              </span>
            } 
            key="admin" 
          />
        </Tabs>

        <Form
          style={{
            padding: "0px 60px 30px 60px",
          }}
          id="signInForm"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              marginTop: "24px",
              marginBottom: "24px"
            }}
          >
            <img src={landingLogo} alt="Logo" style={{ height: "80px", marginBottom: "20px" }} />

            <Input
              placeholder="Enter User Code"
              value={userCode}
              onChange={userChange}
              style={{
                padding: "13.3px 24px",
                borderRadius: "50px",
                background: "transparent",
                width: "100%",
                border: "none",
                outline: "none",
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "1.5",
                color: "#1777C4",
                WebkitAppearance: "none",
                WebkitBoxShadow: "inset 3px 3px 6px #bfc3cf, inset -3px -3px 6px #fff",
                boxShadow: codeIsValid
                  ? "inset 3px 3px 6px #bfc3cf, inset -3px -3px 6px #fff"
                  : "inset 3px 3px 6px rgba(255, 0, 0, 0.3), inset -3px -3px 6px #fff",
                height: "50px",
                borderColor: codeIsValid ? "transparent" : "red",
                ...(codeIsValid ? {} : { border: "1px solid rgba(255, 0, 0, 0.5)" })
              }}
            />
          </div>

          <Form.Item style={{ marginBottom: "32px" }}>
            <Input.Password
              placeholder="Enter Password"
              value={password}
              onChange={passwordChange}
              style={{
                padding: "13.3px 24px",
                borderRadius: "50px",
                background: "transparent",
                width: "100%",
                border: "none",
                lineHeight: "1.5",
                fontSize: "16px",
                fontWeight: "500",
                color: "#1777C4",
                WebkitAppearance: "none",
                WebkitBoxShadow: "inset 3px 3px 6px #bfc3cf, inset -3px -3px 6px #fff",
                height: "50px",
                boxShadow: passwordValid
                  ? "inset 3px 3px 6px #bfc3cf, inset -3px -3px 6px #fff"
                  : "inset 3px 3px 6px rgba(255, 0, 0, 0.3), inset -3px -3px 6px #fff",
                borderColor: passwordValid ? "transparent" : "red",
                ...(passwordValid ? {} : { border: "1px solid rgba(255, 0, 0, 0.5)" })
              }}
            />
          </Form.Item>

          <Form.Item style={{ textAlign: "center", marginBottom: "0" }}>
            <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  borderRadius: "50px",
                  width: "120px",
                  height: "45px",
                  fontWeight: "600",
                  backgroundColor: "#1777C4",
                  fontSize: "16px",
                  boxShadow: "0 4px 12px rgba(23, 119, 196, 0.4)",
                }}
                onClick={submitHandler}
              >
                Sign In
              </Button>

              {usertype === "Administrator Module" && (
                <Link to="/signup">
                  <Button
                    type="default"
                    style={{
                      borderRadius: "50px",
                      width: "120px",
                      height: "45px",
                      fontWeight: "600",
                      color: "#1777C4",
                      border: "2px solid #1777C4",
                      background: "#fff",
                      fontSize: "16px",
                    }}
                  >
                    Sign Up
                  </Button>
                </Link>
              )}
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default SignIn;